import ButtonIconH from "./ButtonIconH";
import moment from "moment";
import "../css/GlassesHistoryBox.css";
import { formatValueUnit } from "../js/utils";
import { reformatField } from "../js/format";

export default function ContactLensesHistoryBox({ data, onOpen }) {
  const formatOptoFloat = (value) =>
    value === "" || value === null || value === undefined
      ? ""
      : reformatField(String(value), "type-optofloat");

  return (
    <div className="history-box">
      <div className="history-box-header">
        <div
          className="history-box-header-fields"
          style={{
            padding: "0px 20px",
            height: "30px",
          }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Fecha</span>
            <span>{moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Realizada por</span>
            <span>{data.empleado}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Pruebas realizadas</span>
            <span>{data.numPruebas}</span>
          </div>
        </div>
        <div style={{ padding: "5px" }}>
          <ButtonIconH text="Mostrar" small onClick={onOpen}></ButtonIconH>
        </div>
      </div>
      <div className="history-box-content">
        <span className="history-box-tag history-box-title-bg">
          Lente de contacto OD
        </span>
        <div className="history-box-content-header cl-grid-columns">
          <span className="history-box-tag">Nombre comercial</span>
          <span className="history-box-tag">Tipo</span>
          <span className="history-box-tag">Uso</span>
          <span className="history-box-tag">Esf</span>
          <span className="history-box-tag">Cil</span>
          <span className="history-box-tag">Eje</span>
          <span className="history-box-tag">Add</span>
          <span className="history-box-tag">Total</span>
          <span className="history-box-tag">Rad</span>
          <span className="history-box-tag">Rad2</span>
          <span className="history-box-tag">Diá</span>
          <span className="history-box-tag">Total precio</span>
        </div>
        <div className="history-box-content-data cl-grid-columns">
          <span className="history-box-data">{data.OD.nombreComercial}</span>
          <span className="history-box-data">{data.OD.tipo}</span>
          <span className="history-box-data">{data.OD.uso}</span>
          <span className="history-box-data">{formatOptoFloat(data.OD.esf)}</span>
          <span className="history-box-data">{formatOptoFloat(data.OD.cil)}</span>
          <span className="history-box-data">{data.OD.eje}</span>
          <span className="history-box-data">{formatOptoFloat(data.OD.add)}</span>
          <span className="history-box-data">{formatOptoFloat(data.OD.total)}</span>
          <span className="history-box-data">{data.OD.rad}</span>
          <span className="history-box-data">{data.OD.rad2}</span>
          <span className="history-box-data">{data.OD.dia}</span>
          <span className="history-box-data">
            {formatValueUnit(data.OD.totalPrecio, "€")}
          </span>
        </div>
        <span className="history-box-tag history-box-title-bg">
          Lente de contacto OI
        </span>
        <div className="history-box-content-header cl-grid-columns">
          <span className="history-box-tag">Nombre comercial</span>
          <span className="history-box-tag">Tipo</span>
          <span className="history-box-tag">Uso</span>
          <span className="history-box-tag">Esf</span>
          <span className="history-box-tag">Cil</span>
          <span className="history-box-tag">Eje</span>
          <span className="history-box-tag">Add</span>
          <span className="history-box-tag">Total</span>
          <span className="history-box-tag">Rad</span>
          <span className="history-box-tag">Rad2</span>
          <span className="history-box-tag">Diá</span>
          <span className="history-box-tag">Total precio</span>
        </div>
        <div className="history-box-content-data cl-grid-columns">
          <span className="history-box-data">{data.OI.nombreComercial}</span>
          <span className="history-box-data">{data.OI.tipo}</span>
          <span className="history-box-data">{data.OI.uso}</span>
          <span className="history-box-data">{formatOptoFloat(data.OI.esf)}</span>
          <span className="history-box-data">{formatOptoFloat(data.OI.cil)}</span>
          <span className="history-box-data">{data.OI.eje}</span>
          <span className="history-box-data">{formatOptoFloat(data.OI.add)}</span>
          <span className="history-box-data">{formatOptoFloat(data.OI.total)}</span>
          <span className="history-box-data">{data.OI.rad}</span>
          <span className="history-box-data">{data.OI.rad2}</span>
          <span className="history-box-data">{data.OI.dia}</span>
          <span className="history-box-data">
            {formatValueUnit(data.OI.totalPrecio, "€")}
          </span>
        </div>

        <span className="history-box-tag history-box-title-bg">Líquido</span>
        <div className="history-box-content">
          <div
            className="history-box-header-fields"
            style={{ backgroundColor: "#f9f9f9" }}
          >
            <div className="history-box-header-field">
              <span className="history-box-tag">Proveedor</span>
              <span>{data.liquido.proveedor || "-"}</span>
              <span className="history-box-tag">Marca</span>
              <span>{data.liquido.marca || "-"}</span>
              <span className="history-box-tag">Nombre comercial</span>
              <span>{data.liquido.nombreComercial || "-"}</span>
            </div>
            <div className="history-box-header-field">
              <span className="history-box-tag">Total</span>
              <span>{formatValueUnit(data.liquido.total, "€")}</span>
            </div>
          </div>
        </div>

        <div
          className="history-box-header-fields"
          style={{
            padding: "0px 20px",
            height: "30px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Total ficha</span>
            <span>{formatValueUnit(data.totalFicha, "€")}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
